<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="600px" data-app ligth>
      <slot name="showButtonSlot" slot="activator"></slot>
      <v-card>
        <v-card>
          <slot name="modal_title"></slot>
        </v-card>
        <v-card-text>
          <v-container grid-list-md>
            <!--<slot name="modal_body"></slot>-->
            <div v-html="text"></div>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!--<slot name="modal_footer"></slot>-->
          <v-btn color="blue darken-1" flat @click="dialog = false">{{$t('btnClose')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>


<script>
  export default {
    name: 'AppModal',
    methods: {
      childEvent() {
        //this.$emit('chilEventAkcija');
      },

      setModalText(text) {
        this.text = text;
      }

    },
    mounted() {
      
    },
    data: () => ({
      text: '',
      dialog: false
    })
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Common/Components/AppModal.vue